/* eslint-disable camelcase */
import React, { useState } from "react";
import {
  Row,
  Column,
  Container,
  Loader,
  ActionBar,
  Heading,
  Details,
  DetailsItem,
  PictureGallery,
  DetailsHeaderItem,
  DetailsPicture,
  ActionBarButtons,
  EditActionButton,
  ExportActionButton,
  DeleteActionButton,
  ContextualHelp,
  withApi,
  withUser,
  withBrowser,
  withAccessRights,
  apiShape,
  accessRightsShape,
  htmlFormat,
  htmlLink,
  intlShape,
  browserShape,
  withNotifier,
  notifierShape,
  NotFoundError,
  pullValueFromSpec,
  pullUpdatedAtFromSpec,
  withIntl,
} from "lcm-iot-commons";

import { FormattedMessage } from "react-intl";

import {
  gatewayIconClassName,
  fieldGatewayStatusIconClassName,
} from "../../utils/statusUtils";
import { FieldGatewayModbusConfigItem } from "./FieldGatewayModbusConfigItem";
import { FieldGatewayGenericModbusDetails } from "./FieldGatewayGenericModbusDetails";
import { getFieldGatewayImageUrl } from "./PicturePoolUrl";

import {
  FieldGatewayTypes,
  EHEdmSpecificationKeys,
  FieldGatewayConstants,
} from "./FieldGatewayConstants";

const getChannelNameByString = (channel: $TSFixMe) =>
  channel === "0" ? FieldGatewayConstants.ch0LiquilinePlattform : `${channel}`;

const getStringAsShownInValueApp = (orgName: $TSFixMe) =>
  orgName
    .replaceAll(".", " ")
    .toLowerCase()
    .split(" ")
    .map((word: $TSFixMe) => word.charAt(0).toUpperCase() + word.substring(1))
    .join(" ");

export const sortByModbusRegister = (modbusConfig: $TSFixMe) =>
  modbusConfig
    .slice()
    .sort((a: $TSFixMe, b: $TSFixMe) => a.regName.localeCompare(b.regName));

export const getModbusConfig = (response: $TSFixMe) => {
  if (!response.specifications) {
    return [];
  }
  const result: $TSFixMe = [];
  const specificationNames = Object.keys(response.specifications).filter(
    (specKey) =>
      specKey.includes(FieldGatewayConstants.configAiKeyPrefix) ||
      specKey.includes(FieldGatewayConstants.configDiKeyPrefix),
  );
  specificationNames.forEach((specName) => {
    const specValue = pullValueFromSpec(response.specifications, [
      specName,
    ]).split(";");
    const specSubKeys = specName.split(".");
    if (specValue.length === 2 && specSubKeys.length === 2) {
      result.push({
        valueName: getStringAsShownInValueApp(specValue[1]),
        channel: getChannelNameByString(specValue[0]),
        regName: specSubKeys[1],
      });
    }
  });

  return sortByModbusRegister(result);
};

export const getInitialModbusConfigExportKeys = (response: $TSFixMe) => {
  if (!response.specifications) {
    return [];
  }
  return Object.keys(response.specifications).filter(
    (specKey) =>
      specKey.includes(FieldGatewayConstants.configAiKeyPrefix) ||
      specKey.includes(FieldGatewayConstants.configDiKeyPrefix) ||
      specKey.includes(FieldGatewayConstants.configModbusKeyPrefix),
  );
};

const isEmpty = (obj: $TSFixMe) => Object.keys(obj).length === 0;

export const getInitialModbusConfigStatusExportKeys = (response: $TSFixMe) => {
  if (!response.specifications) {
    return [];
  }
  return Object.keys(response.specifications).filter((specKey) =>
    specKey.includes(FieldGatewayConstants.configStatusKeyPrefix),
  );
};

export const getModbusConfigExport = (response: $TSFixMe) => {
  if (!response.specifications) {
    return [];
  }
  const specificationNames = getInitialModbusConfigExportKeys(response);
  return specificationNames.map((specName) => ({
    key: specName,
    value: `${pullValueFromSpec(response.specifications, [specName])}`,
    updated_at: `${pullUpdatedAtFromSpec(response.specifications, [specName])}`,
  }));
};

export const getModbusConfigStatusExport = (response: $TSFixMe) => {
  if (!response.specifications) {
    return [];
  }
  const specificationNames = getInitialModbusConfigStatusExportKeys(response);
  return specificationNames.map((specName) => ({
    key: specName,
    value: `${pullValueFromSpec(response.specifications, [specName])}`,
    updated_at: `${pullUpdatedAtFromSpec(response.specifications, [specName])}`,
  }));
};

export const getInitialGenericModbusKeys = (response: $TSFixMe) =>
  Object.keys(response.specifications).filter((specKey) =>
    specKey.includes(FieldGatewayConstants.configModbusKeyPrefix),
  );

export const getGenericModbusConfig = (response: $TSFixMe) => {
  if (!response.specifications) {
    return [];
  }
  const specificationNames = getInitialGenericModbusKeys(response);
  return specificationNames.map((specName) => ({
    key: specName,
    value: `${pullValueFromSpec(response.specifications, [specName])}`,
    updated_at: `${pullUpdatedAtFromSpec(response.specifications, [specName])}`,
  }));
};

export const createFileData = (data: $TSFixMe) => {
  const jsonObj = {
    config_version: 1,
    config_type: "specifications",
    configuration: {},
    configuration_status: {},
  };

  if (data.byte_order != null) {
    (jsonObj as $TSFixMe).byte_order = data.byte_order;
  }

  if (data.unit_identifier != null) {
    (jsonObj as $TSFixMe).unit_identifier = data.unit_identifier;
  }

  data.modbusConfigExport
    ?.filter(
      (element: $TSFixMe) =>
        element?.key && element?.value && element?.updated_at,
    )
    .forEach((element: $TSFixMe) => {
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      jsonObj.configuration[element.key] = {
        value: element.value,
        updated_at: element.updated_at,
      };
    });

  data.modbusConfigStatusExport
    ?.filter(
      (element: $TSFixMe) =>
        element?.key && element?.value && element?.updated_at,
    )
    .forEach((element: $TSFixMe) => {
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      jsonObj.configuration_status[element.key] = {
        value: element.value,
        updated_at: element.updated_at,
      };
    });

  return JSON.stringify(jsonObj, null, 2);
};

export function extractInitialValues(
  response: $TSFixMe,
  accessRights: $TSFixMe,
) {
  const initialValues = { ...response };
  initialValues.status = response.status.name;
  initialValues.type = response.type?.name;
  initialValues.typeCode = response.type?.code;
  initialValues.isSWG70OrSWG50 =
    response.type.code === FieldGatewayTypes.SWG70 ||
    response.type.code === FieldGatewayTypes.SWG50;
  initialValues.isNXA820 = response.type.code === FieldGatewayTypes.NXA820;
  initialValues.port = response.port?.toString();
  initialValues.hart_address = pullValueFromSpec(response.specifications, [
    EHEdmSpecificationKeys.EH_EDM_HART_ADDRESS,
  ]);
  initialValues.serial_number = pullValueFromSpec(response.specifications, [
    EHEdmSpecificationKeys.EH_EDM_FGW_SERIAL_NUMBER,
  ]);
  initialValues.tag = pullValueFromSpec(response.specifications, [
    EHEdmSpecificationKeys.EH_EDM_FGW_TAG,
  ]);
  initialValues.byte_order = pullValueFromSpec(response.specifications, [
    EHEdmSpecificationKeys.EH_EDM_FGW_BYTE_ORDER,
  ]);
  initialValues.unit_identifier = pullValueFromSpec(response.specifications, [
    EHEdmSpecificationKeys.EH_EDM_FGW_UNIT_IDENTIFIER,
  ]);
  initialValues.icon = fieldGatewayStatusIconClassName(response.status.code);
  initialValues.placeholder = gatewayIconClassName();
  initialValues.editable = accessRights.canUpdate;
  initialValues.isMBTCPLiquiline =
    response.type.code === FieldGatewayTypes.CM44MODBUSTCP;
  initialValues.isMBTCPGeneric =
    response.type.code === FieldGatewayTypes.GENERIC_MODBUS_TCP;
  initialValues.modbusConfig = getModbusConfig(response);
  initialValues.modbusConfigExport = getModbusConfigExport(response);
  initialValues.modbusConfigStatusExport =
    getModbusConfigStatusExport(response);
  initialValues.genericModbusConfig = getGenericModbusConfig(response);
  if (initialValues.typeCode === FieldGatewayTypes.GENERIC_MODBUS_TCP) {
    initialValues.byte_order = initialValues.byte_order ?? "0";
    initialValues.unit_identifier = initialValues.unit_identifier ?? 0;
  }

  return initialValues;
}

export function PrintConfig({ params, intl }: $TSFixMe) {
  return params.map((parameters: $TSFixMe, index: $TSFixMe) => (
    <div
      key={`PrintConfig-${index.toString()}`}
      style={{ marginBottom: "20px" }}
    >
      <FieldGatewayModbusConfigItem
        itemHeader={parameters.valueName}
        itemVariable={parameters.regName}
        itemChannel={parameters.channel}
        intl={intl}
      />
    </div>
  ));
}

type FieldGatewayDetailsProps = {
  api: apiShape;
  intl: intlShape;
  browser: browserShape;
  accessRights: accessRightsShape;
  notifier: notifierShape;
  match: {
    params?: {
      id?: string;
      fieldGatewayId?: string;
    };
  };
};

export function FieldGatewayDetails(props: FieldGatewayDetailsProps) {
  const { api, browser, accessRights, match, intl, notifier } = props;
  const { t } = intl;
  // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type '{ id?: strin... Remove this comment to see the full error message
  const { id, fieldGatewayId } = match.params;
  const [details, setDetails] = useState({});

  const loadData = async () => {
    try {
      const response = await api.get(
        `/edm/edge_devices/${id}/field_gateways/${fieldGatewayId}`,
        { include: "status, type, specifications" },
        false,
      );
      setDetails(extractInitialValues(response, accessRights));
    } catch (error) {
      if (error instanceof NotFoundError) {
        browser.navigateTo("/404");
      } else {
        notifier.showError(api.translateError(error));
        setDetails({});
      }
    }
  };
  React.useEffect(() => {
    loadData();
  }, [id]);

  const onConfirmDelete = async () => {
    try {
      await api.delete(
        `/edm/edge_devices/${id}/field_gateways/${fieldGatewayId}`,
      );
      // @ts-expect-error TS(2349) FIXME: This expression is not callable.
      notifier.showSuccess(t`delete_field_gateway.success_notification`);
      browser.navigateTo(`/edge_devices/${id}`);
    } catch (error) {
      notifier.showError(api.translateError(error));
    }
  };

  const exportFilename = (data: $TSFixMe) =>
    `${data.name !== undefined ? `${data.name}` : ""}@${data.ip_address}.mbconf`;

  const onModbusDataExport = (dataValues: $TSFixMe) => {
    const fileData = createFileData(dataValues);
    const data = new Blob([fileData], { type: "application/json" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(data);
    link.setAttribute("download", exportFilename(dataValues));
    document.body.appendChild(link);
    // start download of the file
    link.click();
    // clean up and remove link element
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    link.parentNode.removeChild(link);
  };

  const {
    // @ts-expect-error TS(2339) FIXME: Property 'icon' does not exist on type '{}'.
    icon,
    // @ts-expect-error TS(2339) FIXME: Property 'name' does not exist on type '{}'.
    name,
    // @ts-expect-error TS(2339) FIXME: Property 'type' does not exist on type '{}'.
    type,
    // @ts-expect-error TS(2339) FIXME: Property 'typeCode' does not exist on type '{}'.
    typeCode,
    // @ts-expect-error TS(2339) FIXME: Property 'status' does not exist on type '{}'.
    status,
    // @ts-expect-error TS(2339) FIXME: Property 'description' does not exist on type '{}'... Remove this comment to see the full error message
    description,
    // @ts-expect-error TS(2339) FIXME: Property 'editable' does not exist on type '{}'.
    editable,
    // @ts-expect-error TS(2339) FIXME: Property 'port' does not exist on type '{}'.
    port,
    // @ts-expect-error TS(2339) FIXME: Property 'placeholder' does not exist on type '{}'... Remove this comment to see the full error message
    placeholder,
    // @ts-expect-error TS(2339) FIXME: Property 'ip_address' does not exist on type '{}'.
    ip_address,
    // @ts-expect-error TS(2339) FIXME: Property 'hart_address' does not exist on type '{}... Remove this comment to see the full error message
    hart_address,
    // @ts-expect-error TS(2339) FIXME: Property 'serial_number' does not exist on type '{... Remove this comment to see the full error message
    serial_number,
    // @ts-expect-error TS(2339) FIXME: Property 'tag' does not exist on type '{}'.
    tag,
    // @ts-expect-error TS(2339) FIXME: Property 'byte_order' does not exist on type '{}'.
    byte_order,
    // @ts-expect-error TS(2339) FIXME: Property 'unit_identifier' does not exist on type ... Remove this comment to see the full error message
    unit_identifier,
    // @ts-expect-error TS(2339) FIXME: Property 'isSWG70OrSWG50' does not exist on type '... Remove this comment to see the full error message
    isSWG70OrSWG50,
    // @ts-expect-error TS(2339) FIXME: Property 'isMBTCPLiquiline' does not exist on type... Remove this comment to see the full error message
    isMBTCPLiquiline,
    // @ts-expect-error TS(2339) FIXME: Property 'isMBTCPGeneric' does not exist on type '... Remove this comment to see the full error message
    isMBTCPGeneric,
    // @ts-expect-error TS(2339) FIXME: Property 'isNXA820' does not exist on type '{}'.
    isNXA820,
    // @ts-expect-error TS(2339) FIXME: Property 'modbusConfig' does not exist on type '{}... Remove this comment to see the full error message
    modbusConfig,
    // @ts-expect-error TS(2339) FIXME: Property 'modbusConfigExport' does not exist on ty... Remove this comment to see the full error message
    modbusConfigExport,
    // @ts-expect-error TS(2339) FIXME: Property 'modbusConfigStatusExport' does not exist... Remove this comment to see the full error message
    modbusConfigStatusExport,
    // @ts-expect-error TS(2339) FIXME: Property 'genericModbusConfig' does not exist on t... Remove this comment to see the full error message
    genericModbusConfig,
  } = details;

  const fieldGatewayImageUrl = getFieldGatewayImageUrl(typeCode, 500);

  return (
    <Container>
      <Row>
        <Column>
          <ActionBar>
            {/* @ts-expect-error TS(2349) FIXME: This expression is not callable. */}
            <Heading title={t`field_gateway.details.header`} />
            <ActionBarButtons>
              <EditActionButton
                id="edit-gateway-button"
                disabled={!editable}
                target={`/edge_devices/${match.params?.id}/field_gateways/${match.params?.fieldGatewayId}/edit`}
              />
              <DeleteActionButton
                id="delete-gateway-button"
                disabled={!editable}
                // @ts-expect-error TS(2349) FIXME: This expression is not callable.
                modalTitle={t`field_gateway.delete.modal_title`}
                // @ts-expect-error TS(2349) FIXME: This expression is not callable.
                modalMessage={t`field_gateway.delete.modal_message`}
                onConfirm={onConfirmDelete}
              />
            </ActionBarButtons>
          </ActionBar>
          {isEmpty(details) && <Loader id="loader" loading />}
          {!isEmpty(details) && (
            <Details>
              <DetailsPicture>
                {typeCode &&
                  (fieldGatewayImageUrl ? (
                    <PictureGallery
                      // @ts-expect-error TS(2322) FIXME: Type '{ additionalPictureUrls: string[]; }' is not... Remove this comment to see the full error message
                      additionalPictureUrls={[fieldGatewayImageUrl]}
                    />
                  ) : (
                    <PictureGallery placeholder={placeholder} />
                  ))}
              </DetailsPicture>
              <DetailsHeaderItem
                id="name"
                translationKey="label.name"
                value={name}
              />
              <DetailsHeaderItem
                id="type"
                translationKey="label.type"
                value={type}
              />
              <DetailsHeaderItem
                id="ip-address"
                translationKey="label.ip_address"
                value={ip_address}
              />
              <DetailsItem
                id="status"
                icon={icon}
                translationKey="label.status"
                value={status}
              />
              <DetailsItem
                id="description"
                translationKey="label.description"
                value={description}
              />
              {isSWG70OrSWG50 && (
                <Details id="swg70-or-swg50-section">
                  <DetailsItem
                    id="hart-address"
                    translationKey="label.hart_address"
                    value={hart_address}
                  />
                  <DetailsItem
                    id="port"
                    translationKey="label.port"
                    value={port}
                  />
                </Details>
              )}
              {isNXA820 && (
                <Details id="nxa820-section">
                  <DetailsItem
                    id="port"
                    translationKey="label.port"
                    value={port}
                  />
                </Details>
              )}
              {(isMBTCPLiquiline || isMBTCPGeneric) && (
                <div id="modbus-tcp-details">
                  {isMBTCPGeneric && (
                    <div>
                      <DetailsItem
                        id="serial-number"
                        translationKey="label.serial_number"
                        value={serial_number}
                      />
                      <DetailsItem
                        id="tag"
                        translationKey="label.tag"
                        value={tag}
                      />
                    </div>
                  )}
                  <ActionBar>
                    {isMBTCPLiquiline && (
                      <Heading
                        id="modbus-process-value-mapping"
                        level={3}
                        // @ts-expect-error TS(2349) FIXME: This expression is not callable.
                        title={t`field_gateway.modbus.config.label`}
                      />
                    )}
                    {isMBTCPGeneric && (
                      <Heading
                        id="modbus-config"
                        level={3}
                        // @ts-expect-error TS(2349) FIXME: This expression is not callable.
                        title={t`field_gateway.modbus.config.label`}
                      >
                        <ContextualHelp
                          // @ts-expect-error TS(2349) FIXME: This expression is not callable.
                          title={t`field_gateway.modbus.config.title`}
                          interactive
                        >
                          <p>
                            <FormattedMessage
                              id="field_gateway.modbus.config.description"
                              values={{
                                ...htmlFormat,
                                // @ts-expect-error TS(2322) FIXME: Type '(...chunks: any[]) => Element' is not assign... Remove this comment to see the full error message
                                a: htmlLink({
                                  href: "https://help.netilion.endress.com/hc/en-us/articles/10913979447324",
                                  target: "_blank",
                                }),
                              }}
                            />
                          </p>
                        </ContextualHelp>
                      </Heading>
                    )}
                    <ActionBarButtons>
                      <EditActionButton
                        id="edit-gateway-button"
                        disabled={!editable}
                        target={`/edge_devices/${match.params?.id}/field_gateways/${match.params?.fieldGatewayId}/edit`}
                      />
                      <ExportActionButton
                        // @ts-expect-error TS(2322) FIXME: Type '{ id: string; modalTitle: any; modalMessage:... Remove this comment to see the full error message
                        id="export-gateway-button"
                        // @ts-expect-error TS(2349) FIXME: This expression is not callable.
                        modalTitle={t`field_gateway.export.modal_title`}
                        // @ts-expect-error TS(2349) FIXME: This expression is not callable.
                        modalMessage={t`field_gateway.export.modal_message`}
                        onConfirm={() =>
                          onModbusDataExport({
                            name,
                            ip_address,
                            byte_order,
                            unit_identifier,
                            modbusConfigExport,
                            modbusConfigStatusExport,
                          })
                        }
                      />
                    </ActionBarButtons>
                  </ActionBar>
                  {isMBTCPLiquiline && (
                    <>
                      <h4>
                        {/* @ts-expect-error TS(2349) FIXME: This expression is not callable. */}
                        <b>{t`field_gateway.modbus.config.item.ai_di_channel`}</b>
                      </h4>
                      <PrintConfig params={modbusConfig} intl={intl} />
                    </>
                  )}
                  <FieldGatewayGenericModbusDetails
                    // @ts-expect-error TS(2322) FIXME: Type '{ id: string; specifications: any; serialNum... Remove this comment to see the full error message
                    id="section-modbus-details"
                    specifications={genericModbusConfig}
                    serialNumber={serial_number ?? "-"}
                    subAddress={unit_identifier ?? 0}
                    intl={intl}
                  />
                </div>
              )}
            </Details>
          )}
        </Column>
      </Row>
    </Container>
  );
}

export default withBrowser(
  withNotifier(
    withApi(
      withUser(
        // @ts-expect-error TS(2345) FIXME: Argument of type 'ForwardRefExoticComponent<Omit<R... Remove this comment to see the full error message
        withIntl(withAccessRights(FieldGatewayDetails, "EDM::EdgeDevice")),
      ),
    ),
  ),
);
